export const it = {
  "auth.signIn": "Accedi",
  "auth.signOut": "Esci",
  "auth.label": "Area riservata",
  "auth.title": "Accedi per vedere le vetture",
  "auth.sub": "Stock in tempo reale da Corea e Giappone, con il prezzo reso nel suo paese. Inserisca la sua e-mail e le inviamo un link — nessuna password da inventare o ricordare.",
  "auth.send": "Inviami il link",
  "auth.sending": "Invio…",
  "auth.why": "Usiamo il suo indirizzo per inviare il link e per rispondere alle sue richieste. Nient'altro, e mai a terzi.",
  "auth.sentLabel": "Controlli la posta",
  "auth.sentTitle": "Il link è partito",
  "auth.sentBody": "Abbiamo inviato un link di accesso a {email}. Lo apra su questo dispositivo ed è fatta.",
  "auth.sentSpam": "Dovrebbe arrivare entro un minuto. Altrimenti guardi nello spam — e verifichi l'indirizzo digitato.",
  "auth.useAnother": "Usa un altro indirizzo",
  "auth.alreadyIn": "Sei connesso",
  "auth.err.invalid_email": "Non sembra un indirizzo e-mail.",
  "auth.err.too_many": "Troppe richieste di link. Attenda qualche minuto.",
  "auth.err.mail_failed": "Non siamo riusciti a inviare l'e-mail. Riprovi tra un momento.",
  "auth.err.link_expired": "Il link è scaduto o è già stato usato. Eccone uno nuovo.",
  "nav.stock": "Vetture disponibili",
  "nav.auctions": "Aste in Giappone",
  "nav.calculator": "Calcolatore d'importazione",
  "nav.how": "Come funziona",
  "nav.contact": "Contatti",
  "common.from": "da",
  "common.to": "a",
  "common.any": "Qualsiasi",
  "common.all": "Tutti",
  "common.loading": "Caricamento…",
  "common.showMore": "Mostrare di più",
  "common.showLess": "Mostrare di meno",
  "common.reset": "Reimpostare",
  "common.close": "Chiudere",
  "common.back": "Indietro",
  "common.km": "km",
  "common.year": "Anno",
  "common.results": "{n} vetture",
  "common.noResults": "Nessuna vettura corrisponde ai filtri",
  "common.noResultsBody": "Provi ad ampliare la fascia di prezzo o gli anni, oppure rimuova un filtro.",
  "common.estimate": "Stima",
  "common.optional": "facoltativo",
  "common.required": "obbligatorio",
  "common.error": "Si è verificato un errore. La preghiamo di riprovare.",
  "common.retry": "Riprovare",
  "home.eyebrow": "Corea · Giappone → Europa",
  "home.title": "Le auto che l'Europa non ha mai avuto.",
  "home.sub": "Vetture sportive e di prestigio selezionate in Corea e Giappone, consegnate a domicilio. Destinazione: {country}. Ogni prezzo indicato comprende dazi doganali, IVA e omologazione.",
  "home.cta": "Vedere le vetture disponibili",
  "home.cta2": "Stimare un'importazione",
  "home.stat.cars": "vetture in annuncio",
  "home.stat.makes": "marche",
  "home.stat.markets": "mercati d'origine",
  "home.why.title": "Perché Corea e Giappone",
  "home.why.kr.title": "In Corea, la guida è a sinistra",
  "home.why.kr.body": "In Corea si circola a destra, quindi ogni vettura coreana ha il volante a sinistra. Può circolare in Francia, Svizzera, Germania e Lussemburgo senza modificare la posizione di guida. Un mercato ampio e con un elevato potere d'acquisto, dove le auto vengono usate intensamente e che gli acquirenti europei non vedono.",
  "home.why.jp.title": "Il Giappone le conserva con cura",
  "home.why.jp.body": "Le vetture in Giappone sono note per il basso chilometraggio e la cura nella manutenzione. Il sistema di valutazione delle aste permette di conoscerne lo stato prima di fare un'offerta. Proponiamo solo vetture con guida a sinistra: sportive europee d'eccezione vendute nuove in Giappone.",
  "home.why.price.title": "Un prezzo, nessun costo nascosto",
  "home.why.price.body": "Ogni vettura riporta il costo fino a casa Sua: acquisto, esportazione, trasporto marittimo, dazi doganali, IVA, omologazione e immatricolazione. Nessun prezzo civetta con sorprese al porto.",
  "home.featured": "Disponibili ora",
  "home.featuredAll": "Vedere tutte le vetture",
  "stock.title": "Vetture disponibili",
  "stock.sub": "Disponibilità aggiornata da Corea e Giappone. I prezzi indicati sono stime del prezzo reso. Destinazione: {country}.",
  "stock.filters": "Filtri",
  "stock.sort": "Ordinare",
  "stock.sort.newest": "Annunci più recenti",
  "stock.sort.price_asc": "Prezzo reso crescente",
  "stock.sort.price_desc": "Prezzo reso decrescente",
  "stock.sort.year_desc": "Anno: più recenti",
  "stock.sort.mileage_asc": "Chilometraggio crescente",
  "stock.search": "Cercare marca, modello…",
  "stock.f.make": "Marca",
  "stock.f.model": "Modello",
  "stock.f.source": "Mercato",
  "stock.f.price": "Prezzo reso",
  "stock.f.year": "Anno",
  "stock.f.mileage": "Chilometraggio massimo",
  "stock.f.fuel": "Carburante",
  "stock.f.body": "Carrozzeria",
  "stock.f.transmission": "Cambio",
  "stock.f.steering": "Posizione del volante",
  "stock.f.photos": "Solo con foto",
  "stock.f.search": "Cerca",
  "stock.f.noMatch": "Nessun risultato",
  "stock.steering.LHD": "Guida a sinistra",
  "stock.steering.RHD": "Guida a destra",
  "stock.steering.any": "Qualsiasi",
  "stock.clearAll": "Cancellare tutto",
  "car.landedIn": "Prezzo reso — {country}",
  "car.estimateNote": "Stima tutto compreso. L'intervallo riflette le voci che quantifichiamo per ogni vettura.",
  "car.listedAt": "Prezzo pubblicato sul mercato {market}:",
  "car.compare": "Confrontare i paesi",
  "car.compareNote": "La stessa vettura, quattro destinazioni. Imposte e omologazione variano sensibilmente.",
  "car.cheapest": "Più conveniente",
  "car.breakdown": "Composizione del prezzo",
  "car.leadTime": "Tempi di consegna stimati",
  "car.leadTimeDays": "{n} giorni",
  "car.enquire": "Richiedere informazioni su questa vettura",
  "car.enquireSub": "Confermiamo l'importo esatto, ispezioniamo la vettura e ci occupiamo di tutto fino alla consegna a casa Sua.",
  "car.specs": "Scheda tecnica",
  "car.spec.year": "Anno",
  "car.spec.mileage": "Chilometraggio",
  "car.spec.fuel": "Carburante",
  "car.spec.transmission": "Cambio",
  "car.spec.engine": "Motore",
  "car.spec.body": "Carrozzeria",
  "car.spec.colour": "Colore",
  "car.spec.steering": "Posizione del volante",
  "car.spec.seats": "Posti",
  "car.spec.location": "Ubicazione",
  "car.spec.seller": "Venditore",
  "car.advisory": "Possibili lavori aggiuntivi",
  "car.advisoryNote": "Non inclusi nel prezzo sopra indicato. Quasi nulla di questo elenco riguarda una singola vettura: quanto emerge dall'ispezione viene quotato separatamente prima di ogni impegno.",
  "car.advisoryUpTo": "fino a {amount} se fosse necessario tutto",
  "car.priceOnRequest": "Prezzo su richiesta",
  "car.priceOnRequestBody": "Questa vettura è proposta senza prezzo pubblico. Lo richiediamo e le quotiamo il prezzo reso completo.",
  "car.daysOnMarket": "In vendita da {n} giorni",
  "car.daysOnMarketHelp": "Da quanto tempo la vettura è in vendita nel suo mercato d'origine. Una vettura ferma da mesi è di norma trattabile.",
  "car.demoLot": "Lotto esempio",
  "car.demoLotNote": "Lotto dimostrativo, non un'auto acquistabile. Le aste in diretta non sono ancora collegate — i numeri mostrano come verrebbe quotato un lotto reale.",

  // fuel
  "spec.fuel.petrol": "Benzina",
  "spec.fuel.diesel": "Diesel",
  "spec.fuel.electric": "Elettrica",
  "spec.fuel.hybrid": "Ibrida",
  "spec.fuel.petrol-hybrid": "Ibrida benzina",
  "spec.fuel.diesel-hybrid": "Ibrida diesel",
  "spec.fuel.petrol-lpg": "Benzina / GPL",
  "spec.fuel.lpg": "GPL",
  "spec.fuel.hydrogen": "Idrogeno",

  // transmission
  "spec.transmission.automatic": "Automatico",
  "spec.transmission.manual": "Manuale",
  "spec.transmission.semi-automatic": "Semiautomatico",
  "spec.transmission.cvt": "CVT",
  "spec.transmission.dct": "DCT",

  // body
  "spec.body.suv": "SUV",
  "spec.body.sports-car": "Sportiva",
  "spec.body.saloon": "Berlina",
  "spec.body.coupe": "Coupé",
  "spec.body.convertible": "Cabriolet",
  "spec.body.estate": "Station wagon",
  "spec.body.hatchback": "Hatchback",
  "spec.body.mpv": "Monovolume",
  "spec.body.van": "Furgone",
  "spec.body.truck": "Camion",
  "spec.body.city-car": "City car",
  "spec.body.small-car": "Utilitaria",
  "spec.body.compact": "Compatta",
  "spec.body.mid-size": "Media",
  "spec.body.full-size": "Grande berlina",

  // seller
  "spec.seller.dealer": "Concessionario",
  "spec.seller.private": "Privato",
  "spec.seller.auction": "Asta",
  "car.similar": "Vetture simili",
  "car.assumptions": "Ipotesi adottate",
  "car.assumptionsNote": "Questi dati non sono pubblicati dalla fonte. Li confermiamo singolarmente prima di emettere un'offerta vincolante: possono modificare l'importo totale.",
  "car.required": "Obbligatorio",
  "car.quotedPerCar": "Quotato per vettura",
  "car.import.hard": "Difficile da immatricolare in {country}",
  "car.import.hardTitle": "Difficile da immatricolare in {country}",
  "car.import.hardBody": "Questa vettura è importabile, ma l'omologazione non è di routine e la quotiamo caso per caso. Parlatene con noi prima di impegnarvi.",
  "car.import.noTitle": "Non importabile in {country}",
  "car.import.noBody": "Questo marchio non può essere immatricolato in {country} come importazione privata. La vettura resta visibile perché avete seguito un link — cambiate paese qui sopra, potrebbe essere disponibile.",
  "car.import.lightsTitle": "Vettura giapponese — fari da sostituire",
  "car.import.lightsBody": "In Giappone si guida a sinistra: i fari sono orientati per la circolazione a sinistra e vanno sostituiti su ogni vettura che ne proviene. Il marchio non fa differenza. Quotiamo il lavoro per vettura.",
  "car.gone": "Non più disponibile",
  "car.goneBody": "Questa vettura non è più sul mercato. Ci descriva cosa cercava e ne troveremo un'altra.",
  "car.freight": "Modalità di trasporto marittimo",
  "car.freight.roro": "RoRo (più conveniente)",
  "car.freight.container_shared": "Container condiviso",
  "car.freight.container_exclusive": "Container esclusivo",
  "car.coc": "Il costruttore può fornire un certificato di conformità europeo (COC)",
  "car.cocHelp": "Molte vetture europee esportate nuove in Corea o Giappone possono ancora ottenere un COC. Sostituisce l'omologazione individuale e riduce sensibilmente i costi di omologazione.",
  "car.confidence.placeholder": "Indicativo",
  "car.confidence.placeholderHelp": "Valori indicativi — verifiche ancora in corso",
  "car.confidence.estimate": "Stima",
  "car.confidence.estimateHelp": "Stima — la maggior parte dei valori è verificata",
  "car.confidence.researched": "Documentato",
  "car.confidence.researchedHelp": "Valori documentati, a titolo indicativo",
  "auctions.title": "Aste in Giappone",
  "auctions.sub": "In Giappone vengono battute all'asta circa 30 000 vetture ogni settimana. Facciamo offerte per Suo conto, dopo aver letto e tradotto la scheda d'asta.",
  "auctions.upcoming": "Prossimi lotti",
  "auctions.resultsTitle": "Quanto vengono aggiudicate davvero",
  "auctions.resultsSub": "Prezzi di aggiudicazione da vendite recenti in Giappone — {n} risultati su {models} modelli, dal {from} al {to}. Limitato ai marchi che importiamo.",
  "auctions.resultsModel": "Modello",
  "auctions.resultsSales": "Vendite",
  "auctions.resultsMedian": "Aggiudicazione mediana",
  "auctions.grades": "Capire le valutazioni d'asta",
  "auctions.gradesSub": "Ogni vettura viene ispezionata e valutata dalla casa d'aste prima della vendita. Il voto è il numero più importante della scheda.",
  "auctions.grade": "Voto",
  "auctions.interior": "Interni",
  "auctions.lot": "Lotto",
  "auctions.house": "Casa d'aste",
  "auctions.saleDate": "Data di vendita",
  "auctions.estimate": "Prezzo di aggiudicazione stimato",
  "auctions.bidCta": "Richiedere un'offerta all'asta",
  "auctions.notConfigured": "I dati delle aste in tempo reale non sono ancora collegati. I lotti qui sotto sono esempi rappresentativi delle vetture per cui facciamo offerte.",
  "enq.w.gradeMin": "Voto d'asta minimo",
  "enq.w.gradeMinHelp": "Il giudizio dell'ispettore sulla vettura. Da 4 in su è la soglia abituale all'importazione.",
  "enq.w.maxHammer": "Prezzo di aggiudicazione massimo (JPY)",
  "enq.w.maxHammerHelp": "Ciò che non dobbiamo superare. Tutto il resto — export, trasporto, dogana, omologazione — è quotato prima del suo impegno.",
  "auctions.bidTitle": "Facciamo l'offerta per lei",
  "auctions.bidSub": "Ci dica l'auto e il tetto massimo. Ogni settimana seguiamo le aste, leggiamo e traduciamo la scheda di ispezione e torniamo con i lotti su cui vale la pena offrire e il prezzo reso nel suo Paese — prima di qualsiasi offerta.",
  "auctions.bidNote": "Ogni settimana passano circa 30 000 vetture e un lotto resta a schermo pochi minuti. Un mandato permanente è il modo in cui si compra.",
  "auctions.samplesTitle": "Come appare un lotto quotato",
  "market.title": "Alle aste giapponesi",
  "market.headline": "Una {what} comparabile viene aggiudicata intorno a {amount}, su {n} vendite.",
  "market.spread": "La metà è rientrata tra {band}.",
  "market.unsold": "{n} su {total} non hanno raggiunto il prezzo di riserva.",
  "market.unsold.one": "1 su {total} non ha raggiunto il prezzo di riserva.",
  "market.basis": "Solo prezzo di aggiudicazione — al netto di diritti d'asta, export, trasporto, dogana, IVA e omologazione. È un prezzo all'ingrosso, da cui lo scarto con il prezzo reso qui sopra. Dati di terzi; non eravamo presenti a queste vendite.",
  "market.period": "Vendite dal {from} al {to}.",
  "market.scope.model": "{what}, tutti gli anni di modello",
  "market.scope.years": "{what} dal {from}–{to}",
  "auctions.sheetMarks": "Sigle della scheda",
  "calc.title": "Calcolatore d'importazione",
  "calc.sub": "Ha già trovato una vettura? Inserisca il prezzo per stimare il costo, consegnata, omologata e immatricolata.",
  "calc.price": "Prezzo nel mercato d'origine",
  "calc.origin": "Paese in cui si trova la vettura",
  "calc.destination": "Il Suo paese",
  "calc.weight": "Massa in ordine di marcia (kg)",
  "calc.co2": "CO₂ (g/km, WLTP)",
  "calc.cc": "Cilindrata (cm³)",
  "calc.year": "Anno",
  "calc.compute": "Calcolare",
  "calc.co2Help": "La Francia applica imposte elevate sulle emissioni di CO₂. Senza questo dato, la stima non può includere il malus ecologico, che può superare il prezzo della vettura.",
  "calc.weightHelp": "Determina il malus sul peso in Francia e i dazi doganali in Svizzera.",
  "how.title": "Come funziona",
  "how.s1.title": "Scelga la vettura",
  "how.s1.body": "Consulti le disponibilità aggiornate da Corea e Giappone, oppure ci dica cosa desidera. Lo cercheremo, anche tra le vetture che non compaiono mai in un annuncio pubblico.",
  "how.s2.title": "La ispezioniamo",
  "how.s2.body": "Un'ispezione indipendente sul posto, prima di qualsiasi pagamento. Per i lotti all'asta, leggiamo e traduciamo prima la scheda d'asta.",
  "how.s3.title": "Acquistiamo e spediamo",
  "how.s3.body": "Acquisto, radiazione per esportazione, trasporto terrestre e marittimo fino a un porto europeo, con copertura assicurativa completa.",
  "how.s4.title": "Dogana e omologazione",
  "how.s4.body": "Dazi doganali, IVA all'importazione, omologazione individuale o procedura con COC per il Suo paese e tutte le modifiche necessarie per la circolazione su strada.",
  "how.s5.title": "Immatricolata e consegnata",
  "how.s5.body": "Immatricolata a Suo nome, con targhe e consegnata a casa Sua, pronta per la strada.",
  "how.homologation": "Omologazione per paese",
  "how.homologationSub": "La procedura per ammettere una vettura alla circolazione varia da paese a paese. È il passaggio che la maggior parte degli importatori gestisce male.",
  "how.route": "Procedura",
  "how.cost": "Costo abituale",
  "how.leadTime": "Tempi di consegna",
  "how.noCoc": "Senza certificato di conformità europeo (COC)",
  "how.withCoc": "Con certificato di conformità europeo (COC)",
  "how.vat": "IVA all'importazione",
  "how.duty": "Dazi doganali",
  "enq.title": "Richiesta di informazioni",
  "enq.name": "Nome",
  "enq.email": "E-mail",
  "enq.phone": "Telefono",
  "enq.country": "Paese di consegna",
  "enq.message": "Informazioni utili",
  "enq.messagePlaceholder": "Tempistiche, budget, configurazione, permuta…",
  "enq.submit": "Inviare richiesta",
  "enq.sending": "Invio…",
  "enq.success": "Richiesta ricevuta",
  "enq.successBody": "Il Suo riferimento è {ref}. Le risponderemo entro un giorno lavorativo con un'offerta vincolante.",
  "enq.error": "Non è stato possibile inviare la richiesta. La preghiamo di riprovare o di scrivere a contact@apexcars.ch.",
  "enq.wanted": "Ci dica cosa cercare",
  "enq.wantedSub": "La maggior parte delle vetture che vendiamo non compare mai in un annuncio pubblico. Ci descriva la vettura e la cercheremo.",
  "enq.w.make": "Marca",
  "enq.w.model": "Modello",
  "enq.w.yearFrom": "Anno da",
  "enq.w.yearTo": "Anno a",
  "enq.w.budget": "Budget (EUR)",
  "enq.w.mileage": "Chilometraggio massimo (km)",
  "enq.w.colour": "Colore",
  "enq.w.notes": "Configurazione, optional, requisiti irrinunciabili",
  "enq.consent": "Utilizziamo i Suoi dati solo per rispondere a questa richiesta.",
  "footer.tagline": "La ricerca ci muove.",
  "footer.rights": "Tutti i diritti riservati.",
  "footer.disclaimer": "I prezzi indicati sono stime calcolate in base alle norme pubblicate su dazi doganali, IVA e omologazione. Non costituiscono un'offerta. Un'offerta vincolante viene emessa dopo l'ispezione della vettura e la verifica della relativa documentazione.",
  "market.encar": "Corea del Sud",
  "market.goonet": "Giappone",
  "market.jpauction": "Aste in Giappone",
  "common.noPhoto": "Foto non disponibili",
  "common.previous": "Precedente",
  "common.next": "Successivo",
  "common.photo": "Foto {n}",
  "common.language": "Lingua",
  "common.menu": "Menu",
  "common.currency": "Valuta",
  "stock.sourcePrice": "Prezzo d’origine in EUR",
  "car.noRepair": "Nessuna riparazione segnalata",
  "car.repair": "Riparazioni segnalate",
  "car.origin": "Origine preferenziale",
  "home.stat.days": "Permanenza media sul mercato",
};
